import { Modal } from '@mantine/core';
import { useEffect } from 'react';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { SectionDraftsModalBody } from './SectionDraftsModalContent';
import { useMeetingNoteDrafts } from './useMeetingNoteDrafts';

type MeetingNoteDraftsModalProps = {
  meetingNoteId: string | null;
  companyId: string;
  onClose: () => void;
};

export function MeetingNoteDraftsModal({
  meetingNoteId,
  companyId,
  onClose,
}: MeetingNoteDraftsModalProps) {
  const { data, isLoading, isError, error } = useMeetingNoteDrafts(companyId, meetingNoteId);

  useEffect(() => {
    if (isError) {
      notifyAndLogError(
        'Failed to load section drafts',
        'Could not fetch section drafts for this meeting note.',
        error,
        { meetingNoteId },
      );
    }
  }, [isError, error, meetingNoteId]);

  return (
    <Modal
      opened={!!meetingNoteId}
      onClose={onClose}
      title={`Meeting note: ${meetingNoteId ?? ''}`}
      size={1200}
    >
      <SectionDraftsModalBody drafts={data?.drafts} isLoading={isLoading} isError={isError} />
    </Modal>
  );
}
